<template>
  <div>
<v-progress-linear
  class="ma-0"
  v-model="deliveryDiscountProgress"
  :color="deliveryDiscountColor"
  height="5"
  background-color="grey lighten-2">{{ deliveryDiscountProgress }}</v-progress-linear>
<v-card-text
  class="ma-0 pa-0"
  :style="textStyle"
>
{{ deliveryDiscountText }}
</v-card-text>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'delivery-discount-bar',
  metaInfo () {
    return { title: this.$t('cart') }
  },
  props: ['discountdata'],
  computed: {
    ...mapGetters('config', [
      'deliveryConfig', 'theme'
    ]),
    ...mapGetters('cart', [
      'cart', 'cartItemDialog', 'cartAmount', 'cartQty', 'pickupTime'
    ]),
    deliveryDiscountProgress () {
      if (this.cartAmount > this.discountdata.minimum_amount) return 100
      else return this.cartAmount / this.discountdata.minimum_amount * 100
    },
    deliveryDiscountText () {
      let text = parseInt(this.discountdata.discount_percentage) === 100 ? 'free delivery' : this.discountdata.discount_percentage + '% delivery fee discount'
      if (this.deliveryDiscountProgress === 100) {
        return 'Yahoo! You may enjoy '+ text +' now!'
      } else {
        let diff = this.discountdata.minimum_amount - this.cartAmount
        diff = (Math.ceil(diff*20)/20).toFixed(2)
        return 'Add $' + diff + ' more for '+ text +'!'
      }
    },
    deliveryDiscountColor () {
      if (this.deliveryDiscountProgress === 100) {
        return 'green'
      } else if (this.deliveryDiscountProgress >= 50) {
        return 'amber'
      } else {
        return 'red'
      }
    },
    textStyle () {
      let color = this.theme.delivery_condition_text_color ? this.theme.delivery_condition_text_color : 'black'
      return {
        color: color,
        fontSize: '12px'
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/DeliveryDiscountBar.vue